import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getNewStatusFetch, getStatusFetch } from "../../features/action/fetchStatus";
import { getAllRipsForChartFetch, getFalsePrintFileFetch } from "../../features/action/fetchPrint";
import Chart from "./Chart";
import ChartDesigner from "./ChartDesigner";
import TableList from "./TableList";
import TablePrint from "./TablePrint";
import { useSearch } from "../../context/SearchContext";
import { search, searchPrint } from "../../util/sort";
import { getAllEmployeeFetch } from "../../features/action/fetchEmployee";
import ChartRips from "./ChartRips";
import ChartManager from "./ChartManager";

const Dashboard = () => {
  // const { designer, sewing, manager } = useSelector((state) => state.employee);
 const { manager, loadStatus, chart } = useSelector((state) => state.status);
 const { ripsFile, loadingRips } = useSelector((state) => state.printFile);
 const { designer, loadingEmp } = useSelector((state) => state.employee);
 const [filteredStatus, setFilteredStatus] = useState([]);
   const { searchQuery } = useSearch();
  const dispatch = useDispatch();

   useEffect(() => {
       document.body.classList.add("no-scrollbar");
       document.documentElement.classList.add("no-scrollbar");
       return () => {
         document.body.classList.remove("no-scrollbar");
         document.documentElement.classList.remove("no-scrollbar");
       };
     }, []);

   useEffect(() => {
       dispatch(getNewStatusFetch());
       dispatch(getFalsePrintFileFetch());
       dispatch(getStatusFetch());
       dispatch(getAllRipsForChartFetch());
       dispatch(getAllEmployeeFetch());

     }, [dispatch]);

     useEffect(() => {
         const filteredResults = loadStatus &&searchQuery ? search(manager, searchQuery) : manager;
         setFilteredStatus(filteredResults);
       }, [searchQuery, manager]);

  return (
    <div className="flex flex-col w-[100%] my-2 overflow-x-hidden">
      <div className="w-[100%] h-[120px] bg-[#739D00]  rounded-b-lg">
        <div className="flex flex-row w-[100%] my-2 text-center text-[#F2F2F2] text-base text-[1vw] p-2">
          <div className=" text-[1.8vw]">Dashboard</div>
        </div>
      </div>
      <div className="mt-[-40px] w-[97%] m-auto  box-border bg-[#F2F2F2] rounded-t-lg shadow-lg">
        <div className="text-[#9E9E9E]  py-2 px-6">Status Chart</div>
        {loadStatus &&<Chart manager={chart} text="Status Chart" />}
      </div>
     
      <div className="mt-8 w-[97%] m-auto  box-border bg-[#F2F2F2] rounded-t-lg shadow-lg">
        <div className="text-[#9E9E9E]  py-2 px-6">Manager Chart</div>
        {loadStatus && <ChartManager manager={chart} />}
      </div>

      <div className="mt-8 w-[97%] m-auto  box-border bg-[#F2F2F2] rounded-t-lg shadow-lg">
        <div className="text-[#9E9E9E]  py-2 px-6">Rips Chart</div>
        {loadStatus &&<ChartRips manager={ripsFile} text="Rips Chart" />}
      </div>
     
    </div>
  );
};

export default Dashboard;
